module.exports = (__webpack_require__(11))(268);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-id-swiper/src/react-swiper.js from dll-reference vendor
// module id = 498
// module chunks = 2 3 9 33 36 37 47 49